import { configureStore } from "@reduxjs/toolkit";
import dialogSlice from "../components/dialog/dialogSlice";
import userSlice from "../features/user/userSlice";
import drawerSlice from "../components/drawer/drawerSlice";
import menuSlice from "../features/menu/menuSlice";
import userTypeSlice from "../features/userType/userTypeSlice";
import degreeSlice from "../features/degree/degreeSlice";
import inquirySlice from "../features/inquiry/inquirySlice";
import cmsSlice from "../features/cms/cmsSlice";
import seotagSlice from "../features/seotag/seotagSlice";
import testimonialSlice from "../features/testimonial/testimonialSlice";
import blogSlice from "../features/blog/blogSlice";
import faqSlice from "../features/faq/faqSlice";
import bannerSlice from "../features/banner/bannerSlice";
import rightsSlice from "../features/rights/rightsSlice";
import loginSlice from "../features/login/loginSlice";
import paginationSlice from "../features/pagination/paginationSlice";
import settingSlice from "../features/setting/settingSlice";
import gallerySlice from "../features/gallery/gallerySlice";
import attractionsSlice from "../features/attraction/attractionsSlice";
import countrySlice from "../features/country/countrySlice";
import stateSlice from "../features/state/stateSlice";
import citySlice from "../features/city/citySlice";
import serviceSlice from "../features/service/serviceSlice";
import specialtySlice from "../features/specialties/specialtySlice";
import facilitySlice from "../features/facility/facilitySlice";
import hospitalSlice from "../features/hospital/hospitalSlice";
import hospitalTypeReducer from "../features/hospitaltype/hospitalTypeSlice";
import shiftSettingsReducer from "../features/shiftsettings/shiftSettingsSlice";
import branchSlice from "../features/branch/branchSlice";
import appointmentSlice from "../features/Appointment/appointmentSlice";
import doctorSlice from "../features/doctor/doctorSlice";

const store = configureStore({
  reducer: {
    dialog: dialogSlice,
    drawer: drawerSlice,
    user: userSlice,
    menu: menuSlice,
    userType: userTypeSlice,
    degree: degreeSlice,
    inquiry: inquirySlice,
    cms: cmsSlice,
    banner: bannerSlice,
    faq: faqSlice,
    blog: blogSlice,
    testimonial: testimonialSlice,
    seotag: seotagSlice,
    rights: rightsSlice,
    login: loginSlice,
    pagination: paginationSlice,
    setting: settingSlice,
    gallery: gallerySlice,
    attractions: attractionsSlice,
    country: countrySlice,
    state: stateSlice,
    city: citySlice,
    service: serviceSlice,
    specialty: specialtySlice,
    facility: facilitySlice,
    hospital: hospitalSlice,
    hospitalType: hospitalTypeReducer,
    shiftSettings: shiftSettingsReducer,
    branch: branchSlice,
    doctor: doctorSlice,
    appointment: appointmentSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
